import {LanguageContentKeyBase,LanguageContentBase,ComponentLanguageContentBase,} from '@app/database-models'
//Generated Imports
export class LanguageContentKey extends LanguageContentKeyBase 
{




//#region Generated Reference Properties
//#region languageContents Prop
languageContents : LanguageContentBase[];
//#endregion languageContents Prop
//#region componentLanguageContents Prop
componentLanguageContents : ComponentLanguageContentBase[];
//#endregion componentLanguageContents Prop

//#endregion Generated Reference Properties


























}